import { useMutation } from "@tanstack/react-query";
import stripe_services from "services/stripe_services";
import {
  SettlementAccountStatus,
} from "types/stripe";

export function useStripeAccount() {
  const accountMutation = useMutation<SettlementAccountStatus, Error, string>({
    mutationFn: (merchantId: string) =>
      stripe_services.getAccountStatus(merchantId),
  });

  const createMutation = useMutation<SettlementAccountStatus, Error, string>({
    mutationFn: (merchantId: string) =>
      stripe_services.createAccount(merchantId),
  });

  const dashboardMutation = useMutation<string, Error, string>({
    mutationFn: (merchantId: string) =>
      stripe_services.getDashboardLink(merchantId),
  });

  return {
    checkAccount: accountMutation.mutateAsync,
    checking: accountMutation.isPending,
    createAccount: createMutation.mutateAsync,
    creating: createMutation.isPending,
    getDashboardLink: dashboardMutation.mutateAsync,
    loadingDashboard: dashboardMutation.isPending,
  };
}
